import { render } from "./PhotographyView.vue?vue&type=template&id=19c8f437"
import script from "./PhotographyView.vue?vue&type=script&lang=js"
export * from "./PhotographyView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__